import { Middleware } from '@nuxt/types';

const hasPermissionToEditCampaign: Middleware = ({ store, redirect, app }) => {
  // Check if user has access to editing this campaign
  const isPermitted = store.getters[
    'feature/hasPermissionToEditCampaignObjective'
  ](store.getters['campaign/objective']);

  if (!isPermitted) redirect('/error');
};

export default hasPermissionToEditCampaign;
